<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <ng-container *ngFor="let card of resumenCards; index as i">
      <div class="col-3 col-md-2">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route || i === 0 ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow icon-card"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>

              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- SALTO DE FILA después de la 4ta tarjeta (i = 3) -->
      <div *ngIf="i === 3" class="w-100"></div>
    </ng-container>
  </div>
  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsDaily']"
        >
          Metrics daily
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsWeekly']"
        >
          Metrics weekly
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/actionsBacklog']"
        >
          Actions backlog
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalClusters']"
        >
          Cannibal clusters
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/keywordInsights']"
        >
          Keyword insights
        </a>
      </div>
    </div>
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalEdges']"
        >
          Cannibal edges
        </a>
        <a class="btn btn-dark btn-sm btn-reg" [routerLink]="['/observability/seo/localSeo/reviews']"> Reviews </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/technicalAudits']"
        >
          Technical Audits
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/sitemapAudits']"
        >
          Sitemap Audits
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/offPagePerformance']"
        >
          Off-page
        </a>
      </div>
    </div>
  </div>
  <div class="row mb-4">
    <div class="col-12">
      <div class="card shadow-sm border-0 bg-light p-3">
        <div class="row align-items-center">
          <div class="col-md-6">
            <label class="form-label text-xs font-weight-bold"
              >State Filter</label
            >
            <div class="btn-group w-100" role="group">
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                (click)="setState('pending_approval')"
                [class.active]="state === 'pending_approval'"
              >
                Pending Approval
              </button>
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                (click)="setState('approved')"
                [class.active]="state === 'approved'"
              >
                Approved
              </button>
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                (click)="setState('executing')"
                [class.active]="state === 'executing'"
              >
                Executing
              </button>
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                (click)="setState('done')"
                [class.active]="state === 'done'"
              >
                Done
              </button>
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                (click)="setState('failed')"
                [class.active]="state === 'failed'"
              >
                Failed
              </button>
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                (click)="setState('')"
                [class.active]="state === ''"
              >
                All
              </button>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label text-xs font-weight-bold">Priority</label>
            <select
              class="form-select form-select-sm"
              [(ngModel)]="priority"
              (change)="getData()"
            >
              <option value="">All Priorities</option>
              <option value="P0">P0 (Critical)</option>
              <option value="P1">P1 (High)</option>
              <option value="P2">P2 (Normal)</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table
          class="table table-bordered table-striped align-items-center mb-0"
        >
          <thead class="thead-light">
            <tr>
              <th>Priority</th>
              <th>Type</th>
              <th>Location</th>
              <th>State</th>
              <th>Created At</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let action of data"
              (click)="openAction(action)"
              style="cursor: pointer"
            >
              <td class="text-center">
                <span
                  class="badge badge-sm"
                  [ngClass]="{
                    'bg-gradient-danger': action.priority === 'P0',
                    'bg-gradient-warning': action.priority === 'P1',
                    'bg-gradient-info': action.priority === 'P2',
                  }"
                >
                  {{ action.priority }}
                </span>
              </td>
              <td class="text-xs font-weight-bold">
                {{ action.type | uppercase }}
              </td>
              <td>
                <div class="d-flex flex-column">
                  <span class="text-sm font-weight-bold">{{
                    action.entity?.locationId?.title || "Unknown"
                  }}</span>
                  <span class="text-xs text-secondary">{{
                    action.entity?.locationId?.gbpLocationName
                  }}</span>
                </div>
              </td>
              <td>
                <span class="badge badge-sm bg-gradient-dark">{{
                  action.state | uppercase
                }}</span>
              </td>
              <td class="text-xs">{{ action.createdAt | date: "short" }}</td>
              <td class="text-center">
                <i class="fas fa-chevron-right text-xs text-secondary"></i>
              </td>
            </tr>
            <tr *ngIf="data.length === 0">
              <td colspan="6" class="text-center py-4">
                No actions found in queue
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      class="card-footer py-2 d-flex justify-content-between align-items-center"
    >
      <small class="text-secondary text-xs"
        >Page {{ currentPage }} of {{ totalPages }}</small
      >
      <nav>
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="changePage(currentPage - 1)"
              >Previous</a
            >
          </li>
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" (click)="changePage(currentPage + 1)">Next</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
